import React from 'react'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import parse from 'html-react-parser';
const DocumentDataCell = ({ item }) => {
    return (
        <>
            <div className='col-lg-12 col-md-12 col-12'>
                <div className='card mb-2 p-3 bg-white shadow-sm'>
                    <div className='d-flex'>
                        <div><PictureAsPdfIcon /></div>
                        <div className='ms-3 d-flex justify-content-between align-items-center  w-100'>
                            <h5 className='f14 mb-2 flex-grow-1'> {item?.name}</h5>
                            {/* {item?.date?<><p className='f12 mb-1 d-none'>Date Added: {item?.date}</p></>:null} */}
                            <div className='d-inline-block position-relative' >
                                <a href={item?.document} target="_blank">
                                    <div className="tiltbgred ps-3 pe-3 f12 position-relative text-white" style={{ zIndex: '1' }}>Download</div>
                                </a>
                            </div>
                        </div> 
                    </div>
                    {item?.description!=null?<> <hr />
                    <div className='f12'>
                         <div className='mb-3'>{parse(`${item?.description}`)}</div>
                    </div></>:<></>}
                </div>
            </div>
        </>
    )
}

export default DocumentDataCell